module.exports = __webpack_public_path__ + "static/3-e4ea32041334c88571d7db23ef981ea2.jpg";